import OfflinePushInfoManager from './offlinePushInfoManager';

export * from './const';
export * from './interface';

export default OfflinePushInfoManager.getInstance();
